<div class="col-12" *ngIf="isLoading">
  <app-busy></app-busy>
</div>

<div class="container-fluid">

  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h4><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Annual Compliance Certificates for Account: {{Carrier.name}}</b>
      </h4>
    </div>
  </div>
  <hr>

  <div class="row">
    <div class="col-sm-12">
      <!-- <label><strong>Account Balance</strong></label>
      <input class="form-control-plaintext" type="text" [ngModel]="dataCntrl.carrier.account_balance"
       readonly /> -->
       <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Account Number</th>
            <th>Account Name</th>
            <th>Trading Name</th>
            <th>Registration Number</th>
            <!-- <th>Lead User</th>
            <th>Carrier Type Description</th> -->
            <th>Account Balance</th>
            <!-- <th>Account Status</th> -->
            </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{Carrier.carrier_code}}</td>
                <td>{{Carrier.name}}</td>
                <td>{{Carrier.trading_name}}</td>
                <td>{{Carrier.registration_number}}</td>
                <!-- <td>{{Carrier.link_person}}</td>
                <td>{{Carrier.carrier_type_description}}</td> -->
                <td class="balance">{{formatCurrency(Carrier.account_balance * -1)}}</td>
                <!-- <td>{{Carrier.status}}</td> -->
              </tr>
            </tbody>

     </table>
    </div>
  </div>
  <hr>
  
  <div class="row">
    <div class="col-9">
      <h5 class=""><i class="fa fa-building"></i><b>CERTIFICATES</b></h5>
    </div>    
  </div>

  <div class="row">
    <div class="col-md-12">
      <ngx-loading [show]="isLoading"></ngx-loading>
      <div *ngIf="!carrierpermitlist ">
        <h6> you have no permits that have annual compliance.</h6>
      </div>
      <table class="table table-sm table-striped" *ngIf="carrierpermitlist">
        <thead>
          <tr>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Permit Num 
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;max-width: 6em;">Permit Type 
            </th>
            <th rowspan="1" title="permit type description" style=" text-align: center !; max-width: 6em;">Route 
            </th>

            <th rowspan="2" title="permit type description" style="text-align: center !important;">Vehicle 
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Compliance due date 
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Status
            </th>
            <th rowspan="2" title="permit type description" style="text-align: center !important;">Action 
          </th>
          </tr>
        </thead>
        <tbody>
          
          <tr *ngFor="let item of carrierpermitlist| paginate: { itemsPerPage: 10, currentPage: page }">
            <td align="center">{{item.permit_num}}</td>
            <td align="center" style="max-width: 3em;">{{item.permit_type}} </td>
            <td   style="max-width: 6em;">{{item.route}}</td>
            <td align="center">{{item.VN_num}}</td>
            <td align="center">{{item.compliant_duedate | date : 'dd/MM/yyyy'}}</td>
            <td align="center" [ngClass]="{'compliant' : item.compliance_status_id == 0,'due' : item.compliance_status_id < 0,'overDue' : item.compliance_status_id < 0 }">{{item.compliance_status}}</td>
            <td style="text-align: center !important; ">
              <div *ngIf="!isView && item.compliance_status_id != 4" style="display: inline-block;padding-left: 5%;"><button (click)="showDetails(item)" class="navigateBtn">Apply</button></div>
              <div *ngIf="!isView && item.compliance_status_id == 4" style="display: inline-block;padding-left: 5%;"><button (click)="showDetails(item)" class="navigateBtn">Continue</button></div>
              <div *ngIf="isView" style="display: inline-block;padding-left: 5%;"><button (click)="viewComplianceApplication(item)" class="navigateBtn">View</button></div>
            </td>
          </tr>
          <tr *ngIf="carrierpermitlist.length > 10">
            <td colspan="4" class="rm-brd" style="text-align: center;">
              <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
            </td>
          </tr> 
        </tbody>
        <tfoot style="padding:0px;margin:0px;">
          <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">
                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                    </div> 
                    
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize"
                      (change)="onChange()">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <!-- <div class="col-8 text-center">
                  <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)"
                    style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div> -->
              </div>
            </td>
          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No carrier compliance found.</span>
            </td>
          </tr>
        </tfoot>
      </table>


    </div>

  </div>
  <div>
    <div class="card-data">
      <div class="col-md-12">
        <button title="Back" type="button" id="btnBack" class="btn btn-md btn-primary pull-right"
          style="margin-left:10px;" (click)="goBack()">Back</button>
      </div>
    </div>
  </div>
</div>